<script>
import Pagination from "../mixins/Pagination";
import ApiService from "../utils/ApiService";

export default {
    name: "DialogSelectFiles",
    mixins: [Pagination],
    data() {
        return {
            visible: false,
            params: {
                q: '',
                email_status: '',
                dir: 0,
                orderby: 'name',
                order: 'asc'
            },
            showDirDialog: false,
            dir: {
                id: 0,
                name: null,
                parent_id: null,
                description: null,
            },
            curDir: {},
            curDirPaths: [],
            pageSize: 10
        }
    },
    methods: {
        open() {
            this.visible = true;
        },
        close() {
            this.visible = false;
        },
        listApi() {
            return '/buildium/reports/files'
        },
        listParams() {
            return this.params;
        },
        loadFiles(dir) {
            this.params.dir = dir;
            this.page = 1;
            this.fetchList();
            if (dir) {
                ApiService.get('/buildium/reports/dirs/' + dir).then(response => {
                    this.curDir = response.data.dir;
                    this.curDirPaths = response.data.paths;
                });
            } else {
                this.curDir = {};
                this.curDirPaths = [];
            }
        },
        formatOwnerName(o) {
            let str = '';
            if (o.FirstName) {
                str += o.FirstName;
            }

            if (o.LastName) {
                str += ' ' + o.LastName;
            }
            return str;
        },
        onSortChange(e) {
            //console.log(e);
            this.params.orderby = e.prop;
            this.params.order = e.order === 'ascending' ? 'asc' : 'desc';
            this.fetchList();
        },
        confirm() {
            this.visible = false;
            this.$emit('confirm', this.selectionIds);
        }
    },
    mounted() {
        this.fetchList();
    }
}
</script>

<template>
    <el-dialog title="Select Files"
               closeable
               :visible.sync="visible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :modal-append-to-body="true"
               :append-to-body="true"
               @close="close"
               width="75%"
    >
        <div v-loading="loading">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>
                    <a @click="loadFiles(0)">All Files</a>
                </el-breadcrumb-item>
                <el-breadcrumb-item
                    v-for="(path,index) in curDirPaths"
                    :key="index"
                >
                    <a @click="loadFiles(path.id)">{{ path.name }}</a>
                </el-breadcrumb-item>
                <el-breadcrumb-item v-if="curDir.id">{{ curDir.name }}</el-breadcrumb-item>
            </el-breadcrumb>
            <el-table :data="dataList" @sort-change="onSortChange"
                      @selection-change="onSelectionChange">
                <el-table-column width="45" type="selection"/>
                <el-table-column label="Name" sortable="custom" prop="name">
                    <template slot-scope="scope">
                        <div class="file-name">
                            <img alt="folder" class="file-name-title__icon" :src="scope.row.icon">
                            <a class="file-name-title__text" @click="loadFiles(scope.row.id)" v-if="scope.row.is_dir">
                                {{
                                    scope.row.name
                                }}
                            </a>
                            <a v-else>{{ scope.row.name }}</a>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="Owners" width="300">
                    <template slot-scope="scope">
                        <div v-if="scope.row.is_dir">-</div>
                        <div v-else>
                            <div v-for="owner in scope.row.owners">
                                <span>{{ formatOwnerName(owner) }}</span>
                                <span><{{ owner.Email ? owner.Email : 'No Email' }}></span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="table-edit-footer">
                <div class="table-actions">
                    <el-pagination
                        background
                        layout="prev, pager, next, total"
                        :total="total"
                        :page-size="pageSize"
                        :current-page="page"
                        @current-change="onPageChange"
                    />
                </div>
                <el-button type="primary" size="medium" :disabled="!selectionIds.length" @click="confirm">Confirm
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>

<style scoped>

</style>